import {
  CommandBarButton,
  IDropdownOption,
  Stack,
  Text,
} from '@fluentui/react';
import {
  FormikCheckBox,
  FormikCountryRegion,
  FormikTextField,
} from 'common/components';
import React from 'react';
import { TravelerCommonData_countries_nodes } from '../../__generated__/TravelerCommonData';
import { useStyles } from './index.styles';
interface AddressFormFieldsProps {
  addressName: string;
  toList: () => void;
  countries: TravelerCommonData_countries_nodes[];
  inputsDisabled: boolean;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}
export const AddressFormFields: React.FC<AddressFormFieldsProps> = ({
  addressName,
  toList,
  countries,
  inputsDisabled,
  setFieldValue,
}) => {
  const styles = useStyles();
  const countryOptions: IDropdownOption[] =
    countries.map((ele) => ({
      key: ele.id,
      text: ele.country,
    })) || [];

  return (
    <>
      <Stack
        horizontal
        horizontalAlign="space-between"
        className={styles.defaultButtonContainer}
      >
        <CommandBarButton
          text="Address List"
          iconProps={{ iconName: 'Back' }}
          onClick={() => {
            toList();
          }}
          className={styles.addressListButton}
        />
      </Stack>
      <Text variant={'xLarge'}>Address</Text>

      <Stack
        horizontal
        tokens={{
          childrenGap: 20,
        }}
        className={styles.formRow}
      >
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.addressLine1`}
            label="Line 1)"
            placeholder="Street and Number, P.O. Box"
            disabled={inputsDisabled}
          />
        </Stack.Item>
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.addressLine2`}
            label="Line 2)"
            placeholder="Apartment, Suite, Unit, Building, Floor"
            disabled={inputsDisabled}
          />
        </Stack.Item>
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.cityName`}
            label="City"
            placeholder="City, Town"
            disabled={inputsDisabled}
          />
        </Stack.Item>
      </Stack>
      <Stack
        horizontal
        tokens={{
          childrenGap: 20,
        }}
        className={styles.formRow}
      >
        <Stack.Item className={styles.countryRegionContainer}>
          <FormikCountryRegion
            countries={countryOptions}
            countryName={`${addressName}.countryId`}
            regionName={`${addressName}.stateRegionId`}
            CountryAutocompleteProps={{
              label: 'Country',
              errorMessage: '',
            }}
            StateRegionAutocompleteProps={{
              label: 'State / Region / Province',
              errorMessage: '',
            }}
            onSelectCountry={(country) =>
              setFieldValue(`${addressName}.country.country`, country)
            }
            onSelectState={(state) =>
              setFieldValue(`${addressName}.stateRegion.stateRegion`, state)
            }
            disabled={inputsDisabled}
          />
        </Stack.Item>
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.postalCode`}
            label="Zip/Postal Code"
            placeholder="Zip/Postal Code"
            disabled={inputsDisabled}
          />
        </Stack.Item>
      </Stack>
      <Stack
        horizontal
        tokens={{
          childrenGap: 20,
        }}
        className={styles.formRow}
      >
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.telephoneNumber`}
            label="Phone"
            placeholder="Phone"
            disabled={inputsDisabled}
          />
        </Stack.Item>
        <Stack.Item className={styles.fieldContainer}>
          <FormikTextField
            name={`${addressName}.emailAddress`}
            label="Email"
            placeholder="Email"
            disabled={inputsDisabled}
          />
        </Stack.Item>
        <Stack horizontal verticalAlign="end" className={styles.fieldContainer}>
          <Stack.Item className={styles.sendCheckBoxContainer}>
            <FormikCheckBox
              name={`${addressName}.isGroundTransferAddress`}
              label="Ground Transfer"
              disabled={inputsDisabled}
            />
          </Stack.Item>
          <Stack.Item>
            <FormikCheckBox
              name={`${addressName}.isDeliveryAddress`}
              label="Delivery"
              disabled={inputsDisabled}
            />
          </Stack.Item>
        </Stack>
      </Stack>
    </>
  );
};
